import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={122.44}
      height={122.487}
      viewBox="0 0 122.44 122.487"
      {...props}
    >
      <path
        data-name="Path 10923"
        d="M61.22 122.486a28.255 28.255 0 01-4.018-.191l.191-3.826c1.148 0 2.487.191 3.635.191v3.826zm-7.844-.574a175.832 175.832 0 01-3.826-.574l.765-3.826c1.148.191 2.487.383 3.635.574zm-7.844-1.339c-1.339-.383-2.487-.765-3.826-1.148l1.148-3.635c1.148.383 2.3.765 3.635 1.148zm-7.461-2.487c-1.148-.574-2.487-.957-3.635-1.53l1.722-3.444c1.148.574 2.3.957 3.444 1.53zm-7.079-3.635a33.275 33.275 0 01-3.444-2.1l2.1-3.252a18.167 18.167 0 003.252 1.913zm-6.5-4.209a34.93 34.93 0 01-3.061-2.487l2.487-2.87 2.87 2.3zm-6.122-5.165a36.726 36.726 0 01-2.678-2.87l2.87-2.487c.765.957 1.722 1.722 2.487 2.678zm-5.172-5.932c-.765-.957-1.53-2.1-2.3-3.252l3.061-2.1c.765.957 1.339 1.913 2.1 3.061zm-4.589-6.5a30.954 30.954 0 01-1.911-3.447l3.444-1.722c.574 1.148 1.148 2.1 1.722 3.252zm-3.635-6.89c-.574-1.148-.957-2.487-1.53-3.635l3.635-1.339c.574 1.148.957 2.3 1.53 3.444zm-2.676-7.461a27.969 27.969 0 01-.957-3.826l3.826-.765a25.486 25.486 0 00.957 3.635zM.765 70.645a28.752 28.752 0 01-.382-3.83l3.826-.383c.191 1.148.191 2.487.383 3.635zm-.767-8.039V58.78l3.826.191v3.635zm4.211-7.461l-3.826-.383c.191-1.339.383-2.678.574-3.826l3.826.574a13 13 0 00-.574 3.635zm1.148-7.27l-3.635-.957c.383-1.339.574-2.487.957-3.826l3.634 1.153c-.382 1.335-.574 2.482-.956 3.63zm2.3-7.078l-3.639-1.339a29.433 29.433 0 011.53-3.635l3.444 1.53a25.55 25.55 0 00-1.34 3.444zm3.061-6.7L7.27 32.379c.574-1.148 1.339-2.3 1.913-3.444l3.252 2.1c-.574.962-1.148 1.918-1.722 3.066zm3.826-6.313l-3.061-2.1a19.316 19.316 0 012.487-3.061l2.87 2.3zm4.778-5.739l-2.87-2.678 2.87-2.87L22 19.367zm5.357-4.974l-2.487-2.87c.957-.765 2.1-1.722 3.061-2.487l2.3 3.061zm5.931-4.4l-1.912-3.249a30.954 30.954 0 013.444-1.913l1.913 3.444a19.293 19.293 0 00-3.445 1.721zm6.5-3.444l-1.53-3.444a29.434 29.434 0 013.635-1.53L40.558 7.7c-1.148.574-2.296.957-3.444 1.531zm6.888-2.674l-1.144-3.635c1.339-.383 2.487-.765 3.826-1.148l.957 3.635c-1.148.382-2.487.765-3.639 1.148zm7.27-1.722l-.57-3.826c1.339-.192 2.678-.383 3.826-.574l.383 3.826c-1.34.188-2.488.382-3.635.574zm7.27-.957L58.35.045h2.87v3.829z"
        fill="#193651"
      />
      <path
        data-name="Rectangle 1614"
        fill="#fff"
        d="M61.794 89.581h38.454v18.94H61.794z"
      />
      <path
        data-name="Path 10924"
        d="M102.161 110.242H59.879V87.665h42.28zm-38.454-3.826h34.627V91.303H63.707z"
        fill="#193651"
      />
      <path
        data-name="Path 10925"
        d="M92.977 108.9H68.87v5.739a5.961 5.961 0 005.931 5.931h12.053a5.961 5.961 0 005.931-5.931V108.9z"
        fill="#fff"
      />
      <path
        data-name="Path 10926"
        d="M87.048 122.487H74.994a7.879 7.879 0 01-7.844-7.844v-7.656h27.932v7.652a8.044 8.044 0 01-8.034 7.848zm-16.262-11.67v3.826a4.041 4.041 0 004.018 4.018h12.053a4.041 4.041 0 004.018-4.018v-3.826z"
        fill="#193651"
      />
      <path
        data-name="Path 10927"
        d="M120.522 42.137c0-22.957-18.749-41.323-41.515-40.175-19.514.957-35.775 16.835-37.5 36.54a40.055 40.055 0 007.27 26.783c6.313 8.992 10.9 8.8 12.244 19.9l.574 4.209h38.454l.383-3.061c1.53-11.479 6.122-11.861 12.818-21.427a38.462 38.462 0 007.272-22.769z"
        fill="#fff"
      />
      <path
        data-name="Path 10928"
        d="M101.969 91.494h-41.9l-.762-5.93c-.957-6.7-2.87-8.609-6.122-11.861a51.635 51.635 0 01-5.931-7.078A43.04 43.04 0 0139.602 38.5C41.515 17.649 58.35 1.2 78.82.048c23.914-1.148 43.619 18.174 43.619 42.088a41.758 41.758 0 01-7.461 24.1 72.19 72.19 0 01-5.931 7.27c-3.444 3.826-5.548 6.122-6.5 13.2zm-38.645-3.826h35.2l.191-1.339c1.148-8.418 3.826-11.479 7.461-15.3a60.308 60.308 0 005.739-6.887 39.19 39.19 0 006.7-22 37.647 37.647 0 00-75.186-3.444 39.2 39.2 0 006.887 25.635 78.159 78.159 0 005.548 6.5c3.444 3.444 6.122 6.122 7.079 14.157z"
        fill="#193651"
      />
      <path
        data-name="Rectangle 1615"
        fill="#193651"
        d="M56.437 87.668h48.976v3.826H56.437z"
      />
      <path
        data-name="Rectangle 1616"
        fill="#193651"
        d="M56.437 97.042h48.976v3.826H56.437z"
      />
      <path
        data-name="Rectangle 1617"
        fill="#193651"
        d="M56.437 106.416h48.976v3.826H56.437z"
      />
      <path
        data-name="Path 10929"
        d="M51.459 33.91a30.018 30.018 0 001.339 18.366L20.659 68.154a8.558 8.558 0 00-3.826 12.053 8.416 8.416 0 0012.435 2.1l28.891-21.423a30.7 30.7 0 0024.488 10.331c13.392-.383 24.679-10.139 27.931-23.148 3.635-16.261-6.313-32.714-22.575-36.54A30.28 30.28 0 0051.459 33.91z"
        fill="#27a2de"
      />
      <g data-name="Group 525" fill="#fff">
        <path
          data-name="Path 10930"
          d="M78.055 57.25l.574 3.826 5.739-.191.383-4.018a19.812 19.812 0 006.122-2.678l3.252 2.3 4.018-4.209-2.487-2.87a18.168 18.168 0 002.487-6.313l3.826-.574-.191-5.739-3.826-.383a23.253 23.253 0 00-2.678-6.313l2.3-3.252-4.209-3.826-3.061 2.487a18.167 18.167 0 00-6.313-2.487l-.574-3.826-5.739.191-.383 4.018a19.812 19.812 0 00-6.125 2.673l-3.252-2.3-4.02 4.21 2.487 3.061a18.168 18.168 0 00-2.487 6.313l-3.826.574.191 5.739 3.826.383a19.811 19.811 0 002.681 6.13l-2.3 3.252 4.209 4.017 3.061-2.487a17.856 17.856 0 006.315 2.292z"
        />
        <path
          data-name="Path 10931"
          d="M88.96 37.353a8.41 8.41 0 10-5.165 10.713 8.392 8.392 0 005.165-10.713z"
        />
      </g>
      <path
        data-name="Path 10932"
        d="M80.925 50.554a10.337 10.337 0 01-3.444-20.088 10.833 10.833 0 013.444-.576 10.337 10.337 0 013.444 20.088 10.833 10.833 0 01-3.444.576zm0-16.835a6.877 6.877 0 00-2.1.383 6.479 6.479 0 00-4.018 8.226 6.553 6.553 0 006.122 4.4 6.877 6.877 0 002.1-.383 6.479 6.479 0 004.018-8.226 6.374 6.374 0 00-6.122-4.4z"
        fill="#193651"
      />
    </svg>
  )
}

export default SvgComponent
